import React from "react";
import { Checkbox, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { setTeamFilters } from "../../../../redux/slices/leadSlice";
import useTeams from "../../../../hooks/useTeams";
import CustomSkeleton from "../../../commonComponents/CustomSkeleton";

const TeamFiltersContent = ({
  variables,
  setVariables,
  scrollListToTop,
  clearUrl,
  search = "",
  onFilterChange,
  onClear,
}) => {
  const dispatch = useDispatch();
  const teamFilters = useSelector(state => state.lead.filters.teamFilters || []);
  const { activeTeams, loading } = useTeams();

  if (loading) {
    return (
      <div className="px-3 py-2">
        <CustomSkeleton
          skeletonCount={5}
          skeletonMarginBottom="7px"
          skeletonWidth="28rem"
          skeletonHeight="2rem"
        />
      </div>
    );
  }

  const filteredTeams = (activeTeams || [])
    .filter(t => (t?.name || "").toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => (a?.name || "").toLowerCase().localeCompare((b?.name || "").toLowerCase()));

  const handleToggle = teamId => {
    const idNum = +teamId;
    const current = teamFilters.map(Number);
    const next = current.includes(idNum) ? current.filter(id => id !== idNum) : [...current, idNum];
    setVariables?.({ ...variables, page: 1 });
    dispatch(setTeamFilters(next));
    scrollListToTop?.();
    clearUrl?.();
    onFilterChange?.();
  };

  return (
    <div className="flex flex-col px-3 py-2">
      {onClear && teamFilters.length > 0 && (
        <div className="flex justify-end mb-1">
          <Button type="link" size="small" className="!p-0 !h-auto" onClick={onClear}>
            Clear
          </Button>
        </div>
      )}
      {filteredTeams.length === 0 ? (
        <div className="text-sm text-gray-500 py-3 text-center">No teams</div>
      ) : (
        filteredTeams.map(t => {
          const id = +t.id;
          return (
            <label
              key={id}
              className="flex items-center gap-2 py-1 cursor-pointer hover:bg-gray-50 rounded px-1"
            >
              <Checkbox checked={teamFilters.includes(id)} onChange={() => handleToggle(id)} />
              <span className="text-sm text-[#1F2937] truncate">{t.name}</span>
            </label>
          );
        })
      )}
    </div>
  );
};

export default TeamFiltersContent;
